import { Role } from "src/constants/types";
import { getAccessToken } from "src/api/axiosClient/tokenStorage";

type BhiAdminProfile = { type?: string } | null | undefined;

export const isBhiAdmin = (profile: BhiAdminProfile): boolean =>
  profile?.type === "admin";

// Role hierarchy ordered from most to least privileged.
export const rolesHierarchy = [
  "bhi_admin",
  "company_admin",
  "company_manager",
  "company_user",
];

// True when `roleName` ranks at or above `minRole` in the hierarchy (i.e. is at
// least as privileged). Unknown or absent roles are treated as insufficient.
export const hasRoleAtLeast = (
  roleName: string | undefined,
  minRole: string,
): boolean => {
  if (!roleName) return false;
  const index = rolesHierarchy.indexOf(roleName);
  if (index === -1) return false;
  return index <= rolesHierarchy.indexOf(minRole);
};

export const isActionAllowed = ({
  authorRole,
  userRole,
}: {
  authorRole: string;
  userRole?: string;
  action?: string;
}) => {
  if (rolesHierarchy.indexOf(authorRole) === 0) {
    return true;
  } else if (rolesHierarchy.indexOf(authorRole) === rolesHierarchy.length - 1) {
    return false;
  } else if (rolesHierarchy.indexOf(authorRole) && !userRole) {
    return true;
  } else if (
    userRole &&
    rolesHierarchy.indexOf(authorRole) <= rolesHierarchy.indexOf(userRole)
  ) {
    return true;
  } else {
    return false;
  }
};

export const isPageForbidden = () => {
  return !getAccessToken();
};

export const filterAllowedRoles = (authorRole: string, roles: Role[]) => {
  return roles
    .filter(
      (role) =>
        rolesHierarchy.indexOf(authorRole) <= rolesHierarchy.indexOf(role.name)
    )
    .map((role) => role.id);
};

export const reorderRoles = (roles: Role[]) => {
  const cRoles: Role[] = [];
  rolesHierarchy.map((roleName) => {
    const item = roles.find((role) => role.name === roleName);
    item && cRoles.push(item);
  });
  return cRoles;
};
